import axios from "axios";
import { getApiBaseUrl } from "./config";

const BASE_URL = getApiBaseUrl();

function getErrorMessage(error, fallback) {
  return (
    error.response?.data?.error?.data?.message ||
    error.response?.data?.error?.message ||
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.message ||
    fallback
  );
}

function persistAgentContext(agent) {
  if (!agent) {
    return;
  }

  if (agent.name) {
    localStorage.setItem("agent_name", agent.name);
  }

  const agentTypeId = Array.isArray(agent.agent_type_id) ? agent.agent_type_id[0] : null;
  const agentTypeName = Array.isArray(agent.agent_type_id) ? agent.agent_type_id[1] : "";

  if (agentTypeId) {
    localStorage.setItem("agent_type_id", String(agentTypeId));
  } else {
    localStorage.removeItem("agent_type_id");
  }

  if (agentTypeName) {
    localStorage.setItem("agent_type_name", agentTypeName);
  } else {
    localStorage.removeItem("agent_type_name");
  }
}

export async function login(username, password) {
  try {
    const payload = {
      jsonrpc: "2.0",
      method: "call",
      params: { login: username, password },
      id: new Date().getTime(),
    };

    const res = await axios.post(`${BASE_URL}/web/session/authenticate`, payload, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    if (res.data.error) {
      throw new Error(res.data.error.data?.message || "Login failed");
    }

    return res.data.result;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Login failed"));
  }
}

// ✅ Call any Odoo model method via backend proxy
export async function callOdooModel(model, method, kwargs = {}, args = []) {
  try {
    const payload = {
      jsonrpc: "2.0",
      method: "call",
      params: { model, method, args, kwargs },
      id: new Date().getTime(),
    };

    const res = await axios.post(`${BASE_URL}/web/dataset/call_kw`, payload, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    if (res.data.error) {
      throw new Error(res.data.error.data?.message || "Odoo call_kw failed");
    }

    return res.data.result;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Odoo model call failed"));
  }
}

export async function getCurrentAgentInfo() {
  try {
    const res = await axios.get(`${BASE_URL}/api/profile`, {
      withCredentials: true,
    });
    const agent = res.data;
    if (!agent) throw new Error("Agent not found for current session");

    persistAgentContext(agent);

    return agent;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Agent fetch failed"));
  }
}

export { persistAgentContext };
